// extracted by mini-css-extract-plugin
export var chatHtmlText = "_sj-2";
export var chatLink = "_sj-0";
export var chatText = "_sj-1";